module.exports = __webpack_public_path__ + "img/Loader_Turquesa.70e99924.gif";